module.exports = "/src/views/games/other/images/maps/map_5.png";